import React from "react";
import ListTemplate from "components/ListTemplate";
import Filters from "./Filters";
import { mapFilterValuesToInstruction, mapResponseToFilterValues } from "./helpers";
import { routes } from "utilities/routing/generatedRoutes";
import { DotLabel } from "components/Dot";
import { UserAvatar } from "components/Atoms/Avatar";
import moment from "moment";
import { formatLongDateWithTime } from "utilities";
import { useLoaderData } from "react-router";

const getCalendarTypeName = (type: server.dto.ExternalCalendarTypes) => {
  switch (type) {
    case "googleCalendar":
      return "Google Calendar";
    case "iCalendar":
      return "external ICalendar";
    default:
      return "";
  }
}

const ExternalCalendarName = ({ item }: { item: server.dto.ExternalCalendarForList }) =>
  <div>
    <a href={routes.externalCalendar_Detail(item.externalCalendarId).absolute}>{item.artist.name}</a>
    <span className="s1_gray" title={formatLongDateWithTime(item.lastRefreshUtc)}>
      <DotLabel dotColor={item.active ? "green" : "red"}>
        {item.active ?
          <>{RESX.ExternalCalendar.LastRefresh} {moment.utc(item.lastRefreshUtc).fromNow()}</> :
          RESX.ExternalCalendar.AutomaticRefreshStopped}
      </DotLabel>
    </span>
  </div>

const ExternalCalendarList = () => {
  const viewModel = useLoaderData<server.viewmodel.ExternalCalendarListFrontModel>();

  return <ListTemplate
    perPage={50}
    title={RESX.ExternalCalendar.resxExternalCalendar}
    filterSet="externalCalendar_List"
    defaultFilters={viewModel.defaultFilters}
    initialInstruction={viewModel.initialInstruction}
    fetchFunction={window.CoreApi.ExternalCalendar.Paginated}
    getId={item => item.externalCalendarId}
    layout={{
      type: "table",
      columns: [{
        key: "artist",
        header: RESX.Artist.resxArtist,
        render: item => <ExternalCalendarName item={item} />,
      }, {
        key: "type",
        header: RESX.GeneralLabels.Type,
        render: item => <div>
          <div>{getCalendarTypeName(item.type)}</div>
          <div className="s1_gray">{item.title}</div>
        </div>,
      }, {
        key: "createdBy",
        header: RESX.RecordInformation.CreatedBy,
        render: item => <UserAvatar user={item.createdBy} />,
      }, {
        key: "events",
        header: "Events",
        render: item => item.eventCount,
        size: "fit-content(60px)",
        className: "s1_cell_financialamount"
      }],
    }}
    filters={<Filters />}
    functions={{
      mapResponseToFilterValues,
      mapFilterValuesToInstruction
    }}
  />
}

export default ExternalCalendarList;